<template>
    <div class="hr">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>审核配置</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>审核步骤</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.name" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>

                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" border size="mini" :height="tableConfig.height"
                          :span-method="objectSpanMethod">
<!--                    <el-table-column type="index" label="序号" width="50"/>-->
                    <el-table-column prop="companyName" label="公司名称"  width="250">
                    </el-table-column>
                    <el-table-column prop="step" label="审批步骤" width="250">
                        <template slot-scope="scope" >
                        {{scope.row.step!=null?scope.row.step+'、'+getStepString(scope.row.step)+'级审批'+scope.row.stepName:'--'}}

                        <el-button  type="text" size="mini"   v-if="scope.row.step!=null && showDelete(scope.row)"
                                    style="color: red"     @click='handleDelete(scope.row,"all")'>删除</el-button>

                        </template>

                    </el-table-column>
<!--                    <el-table-column prop="step" label="审批步骤"/>-->
<!--                    <el-table-column prop="stepName" label="审核步骤"/>-->
                    <el-table-column prop="name" label="审核人"  width="200">
                        <template slot-scope="scope" >
                            {{scope.row.name!=null?scope.row.name:'--'}}
                        </template>
                    </el-table-column>


                    <el-table-column label="操作" align="center" width="250" >
                        <template slot="header">
<!--                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>-->
                        </template>
                        <template slot-scope="scope" >
                       <el-button size="mini"  type="text" v-if="scope.row.id != null"    @click="handleEdit(scope.row)">修改</el-button>
                            <el-divider direction="vertical" v-if="scope.row.id != null"  ></el-divider>

                            <el-button size="mini"  type="text" v-if="scope.row.id != null"    @click="addProcessBy(scope.row)">添加审核人</el-button>
<!--                        <el-button  size="mini" v-if="showDelete(scope.row)"-->
<!--                                       @click='handleDelete(scope.row,"all")'>删除</el-button>-->
                            <el-divider direction="vertical" v-if="showDeleteP(scope.row)"  ></el-divider>
                            <el-button size="mini"  type="text" v-if="showDeleteP(scope.row)" style="color: red"
                                        @click="handleDelete(scope.row,'one')">删除审核人</el-button>
                        {{scope.row.id == null?'--':''}}
                        </template>
                    </el-table-column>
                    <el-table-column label="步骤" align="center">
                        <template slot="header">
                            <!--                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>-->
                        </template>
                        <template slot-scope="scope">

                            <el-button type="text" size="mini"  v-if="scope.row.companyId != null"
                                       @click="handleCreate(scope.row.companyId)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background layout="sizes,prev, pager, next"
                                   :page-sizes="[10, 20, 50, 100]" v-if="total>0" :total="total"
                        :page-size="pageSize" @current-change="onPageChange"
                                   @size-change="handleSizeChange"
                                   :current-page="currentPage"
                                   @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="审批步骤" :visible.sync="depDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="depForm" :model="depForm" :rules="rules2" label-width="100px">
                <el-form-item label="步骤" prop="step" >
                    <el-input size="small" style="width: 300px" :disabled="depForm.id != ''"
                              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                              v-model="depForm.step"
                              maxlength="2"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="步骤名称" prop="stepName" >
                    <el-input v-model="depForm.stepName" placeholder="请输入名称" maxlength="28" style="width: 300px"
                              :disabled="isProcessBy" clearable></el-input>
                </el-form-item>
                <el-form-item label="审核人" prop="processedBy">
                    <el-select v-model="depForm.processedBy"  placeholder="请选择审核人"  style="width: 300px" clearable>
                        <el-option
                                v-for="item in cUserData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="depDialogVisible = false">取 消</el-button>
                <el-button type="primary" v-if="depForm.id ==''" @click="onSubmit">添 加</el-button>
                <el-button type="primary" v-if="depForm.id !='' && !isProcessBy" @click="editReview">保存</el-button>
                <el-button type="primary" v-if="isProcessBy" @click="saveProcessBy">添 加</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            companys:[],
            companyTree:[],//可以看到的公司层级
            levels:[],//可以看到的公司层级
            selectData:[],
            userData:[],
            cUserData:[],
            deps:[],
            isProcessBy:false,//添加审核人
            depForm: {
                id: "",
                type:0,
                stepName: "",
                companyId: "",
                step: "",
                processedBy: "",
                processedById: "",


            },
            depDialogVisible: false,
            infoVisible: false,
            searchForm: {
                name: "",
                domain: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            uploadDialogVisible: false,
            fileList: [],
            editForm: {
                departmentId: "",
                departments: "",
                id: "",
                code: "",
                name: "",
                domain: ""
            },
            oldDefine:{},
            peopleForm: {
                stepName:'',
                companys:[],
                pid:"",
                departmentId: "",
                id: "",
                type: "",
                departments: [],
                name: "",
                companyId: ""
            },
            editInvoiceDialogVisible: false,
            editInvoiceForm: {
                id: "",
                companyId: "",
                type: "0",
                companyTaxNo: "",
                bankName: "",
                bankAccount: "",
                registeredTel: "",
                registeredAddress: "",
            },
            options: [],
            rules: {
                code: [
                    { required: true, message: '请输入公司代码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                domain: [
                    { required: true, message: '请输入邮箱域名', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择发票类型', trigger: 'blur' }
                ]

            },
            rules2: {

                stepName: [
                    { required: true, message: '请输入步骤名称', trigger: 'blur' }
                ],
                processedBy: [
                    { required: true, message: '请选择审核人', trigger: 'blur' }
                ],
                step: [
                    { required: true, message: '请输入步骤', trigger: 'blur' }
                ]

            }
        }
    },
    methods: {
        onSearch() {
            let cond = {id:""};
            if (this.searchForm.name != "") {
                cond["name"] = this.searchForm.name;
            }
            this.loading = true;
            let _this = this;

            this.$axios.post("/admin/company/stepList", {
                cond: cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
            });
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },

        handleEdit(row) {
            this.isProcessBy = false;
            this.depForm.id = row.workflowId;
            this.depForm.step = row.step;
            this.depForm.companyId = row.companyId;
            this.depForm.stepName =  row.stepName;
            this.depForm.processedBy =  row.processedBy;
            this.depForm.processedById = row.id;

            this.oldDefine =  {...this.depForm};

            this.cUserData = this.userData.filter(it => it.companyId == row.companyId);
            this.depDialogVisible = true;
        },
        addProcessBy(row) {//添加审核人窗口
            this.isProcessBy = true;
            this.depForm.id = row.workflowId;
            this.depForm.step = row.step;
            this.depForm.companyId = row.companyId;
            this.depForm.stepName =  row.stepName;
            this.depForm.processedBy = "";
            this.depForm.processedById = row.id;

            this.oldDefine =  {...this.depForm};

            //查看公司是否有上级单位 有权限看到的话  就可以设置上级公司的审核人 作为本公司的审核人

            let res = null;
            res = this.getMyNode(this.companyTree,row.companyId,res);
            let pids = [];
            if(res != null){
                this.getPids(this.companyTree, res, pids);//上级单位
            }
            pids.push(row.companyId);

            this.cUserData = this.userData.filter(it => pids.indexOf(it.companyId)>-1 && it.id != row.processedBy);

            // this.cUserData = this.userData.filter(
            //     it => (it.companyId == row.companyId && it.id != row.processedBy));
            this.depDialogVisible = true;
        },
        handleCreate(companyId) {//添加审核步骤 审核人窗口
            this.isProcessBy = false;
            this.depForm.id = "";
            this.depForm.step = "";
            let arr = this.tableData.filter(it => (it.companyId == companyId && it.step != null));
            this.depForm.step = arr.length+1;
            if(arr.length>0){
                this.depForm.step =  arr[arr.length-1].step+1;
            }
            this.depForm.companyId = companyId;
            this.depForm.stepName = "";
            this.depForm.processedBy = "";
            this.depForm.processedById = "";

            //查看公司是否有上级单位 有权限看到的话  就可以设置上级公司的审核人 作为本公司的审核人

            let res = null;
            res = this.getMyNode(this.companyTree,companyId,res);
            let pids = [];
            if(res != null){
                this.getPids(this.companyTree, res, pids);//上级单位
            }
            pids.push(companyId);

            this.cUserData = this.userData.filter(it => pids.indexOf(it.companyId)>-1);

            // this.cUserData = this.userData.filter(it => it.companyId == companyId);
            this.depDialogVisible = true;
        },
        handleEditDep(row) {
            this.depForm.id = row.id;
            this.depForm.name = row.name;
            this.depForm.remark = row.remark;
            this.depDialogVisible = true;
        },
        onSubmit() {//添加审核步骤
            let _this = this;
            this.$refs.depForm.validate(valid => {
                if (valid) {
                    let arr = this.tableData.filter(it => (it.companyId == this.depForm.companyId && it.step != null));
                    let step = arr.length > 0?arr[arr.length-1].step+1:1;
                    if(this.depForm.step>step){
                        this.$notify.error({
                            title: '错误',
                            message: '审核步骤不能跳空'
                        });
                        return;
                    }
                    if(this.depForm.step<step){
                        this.$notify.error({
                            title: '错误',
                            message: '审核步骤已存在'
                        });
                        return;
                    }
                    this.$axios.post("/admin/company/addDefine", this.depForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.depDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        saveProcessBy() {//添加审核人
            let _this = this;
            this.$refs.depForm.validate(valid => {
                if (valid) {

                    this.$axios.post("/admin/company/addProcessBY", this.depForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.depDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },


        add() {
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要添加的员工',
                    duration: 1000
                });
                return;
            }
            let users = [];
            for(let i=0; i<this.selectData.length; i++){
                users.push( {companyId:this.editForm.id,userId:this.selectData[i].id,
                    type:this.selectData[i].type,departmentId:this.editForm.departmentId});
            }

            let msg =  this.selectData.map(it => it.name?it.name:it.email).join(",");
            let _this = this;
            this.$confirm('是否添加员工【' + msg + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.post("/admin/company/addUser",users)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '添加成功',
                                type: 'success'
                            });
                            _this.editDialogVisible = false
                            _this.loadUser();
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        getStepString(step){
            switch(step)
            {
                case 1:
                    return "一";
                case 2:
                    return "二";
                case 3:
                    return "三";
                case 4:
                    return "四";
                case 5:
                    return "五";
                case 6:
                    return "六";
                default:
                    return "";
            }
        },
        editReview() {//编辑审核步骤

            if(this.depForm.stepName == this.oldDefine.stepName &&
                this.depForm.processedBy == this.oldDefine.processedBy){
                this.depDialogVisible = false;
                return;
            }

             let _this = this;
             this.$confirm('是否修改审核步骤？', '确认信息', {
                 distinguishCancelAndClose: true,
                 confirmButtonText: '确认',
                 cancelButtonText: '取消'
             }).then(() => {
                 _this.$axios.post("/admin/company/addDefine",_this.depForm)
                     .then(function (response) {
                         let resp = response.data;
                         if (resp.header.status === 0) {
                             _this.$notify({
                                 title: '成功',
                                 message: '修改成功',
                                 type: 'success'
                             });
                             _this.depDialogVisible = false;
                             _this.onSearch();

                         } else {
                             _this.$notify.error({
                                 title: '错误',
                                 message: resp.header.msg
                             });
                         }
                     });
             })
        },

        loadUser(){
            let _this = this
            this.$axios.post("/admin/company/companyStaff",{id:""}
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.userData = resp.data;
                }

                });

        },

        handleDelete(row,type) {
            let msg = '是否删除审批步骤['+row.stepName+']？';
            let url = "/admin/company/deleteReview";
            let param = row.workflowId;
            if(type == "one"){
                let d =  this.userData.filter(it => it.id == row.processedBy);
                msg = '是否删除审核人['+d[0].name+']？';
                url = "/admin/company/deleteProcessBY";
                param = {id:row.id,workflowId:row.workflowId};
            }
            let _this = this;
            this.$confirm(msg, '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.post(url,param)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据删除成功',
                                type: 'success'
                            });
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        deleteDep(row) {
            let _this = this;
            this.$confirm('是否删除【' + row.name + '】部门？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.post("/admin/company/deleteDep",row.id)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据删除成功',
                                type: 'success'
                            });
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        loadCompany(){
            let _this = this
            this.$axios.post("/admin/company/all"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        selectChanged(companyId) {
            if(companyId != null && companyId != ""){
                let d =  this.deps.filter(it => it.companyId == companyId);
                this.peopleForm.departments = d;
                this.peopleForm.departmentId = null;

            }

        },
        // 合并行
        objectSpanMethod({rowIndex, columnIndex }) {
            let spanOneArr = [],concatOne = 0;
            this.tableData.map((item,index)=>{
                if(index === 0){
                    spanOneArr.push(1);
                }else{
                    //第一列需合并相同内容的判断条件
                    if(item.companyName === this.tableData[index-1].companyName){
                        spanOneArr[concatOne] += 1;
                        spanOneArr.push(0);
                    }else{
                        spanOneArr.push(1);
                        concatOne = index;
                    }
                }
            });

            if(columnIndex === 0 ||columnIndex === 4){
                const _row = spanOneArr[rowIndex];

                const _col = _row > 0 ? 1 : 0;
                // if(columnIndex === 0 ){
                //     console.log("columnIndex:"+columnIndex+",rowIndex:"+rowIndex+",_row:"+_row+",_col:"+_col);
                // }

                return{
                    rowspan:_row,
                    colspan:_col
                }
            }

            let spanOneArr2 = [],concatOne2 = 0;
            this.tableData.map((item,index)=>{
                if(index === 0){
                    spanOneArr2.push(1);
                }else{
                    //第二列需合并相同内容的判断条件
                    if(item.companyName === this.tableData[index-1].companyName
                       &&item.step === this.tableData[index-1].step){
                        spanOneArr2[concatOne2] += 1;
                        spanOneArr2.push(0);
                    }else{
                        spanOneArr2.push(1);
                        concatOne2 = index;
                    }
                }
            });

            if(columnIndex === 1){//合并审核步骤
                const _row = spanOneArr2[rowIndex];

                const _col = _row > 0 ? 1 : 0;
                // if(columnIndex === 0 ){
                //     console.log("columnIndex:"+columnIndex+",rowIndex:"+rowIndex+",_row:"+_row+",_col:"+_col);
                // }

                return{
                    rowspan:_row,
                    colspan:_col
                }
            }
        },
        showDelete(row){
            if(row.step == null)
                return false;
            let arr = this.tableData.filter(it => (it.companyId == row.companyId));
            if(row.step == arr[arr.length-1].step)
                return true;
            return false;
        },
        showDeleteP(row){
            if(row.step == null)
                return false;
            let arr = this.tableData.filter(it => (it.companyId == row.companyId && it.step == row.step));
            if(arr.length>1)
                return true;
            return false;
        },
        loadCompanyLevel(){
            let _this = this;

            this.$axios.post("/admin/company/treeLevel",{id:""}
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companyTree = resp.data;
                    let levels = [];
                    _this.getAllLevels(_this.companyTree,levels);
                    _this.levels = levels;
                }

            });

        },
        getPids(data, target, result){//查找所有父节点 //data：要遍历的数据， target：查找目标， result用于装查找结果的数组
            for (let item of data) {
                if (item.id === target.id) {
                    //将查找到的目标数据加入结果数组中
                    //可根据需求unshift(item.id)或unshift(item)
                    result.unshift(item.id)
                    return true
                }
                if (item.children && item.children.length > 0) {
                    //根据查找到的结果往上找父级节点
                    let isFind = this.getPids(item.children, target, result)
                    if (isFind) {
                        result.unshift(item.id)
                        return true
                    }
                }
            }
            //走到这说明没找到目标
            return false
        },
        getMyNode(tree, childId,res) {//查找节点
            // 遍历树节点
            for (let node of tree) {
                if(node.id == childId){
                    return node;

                }
                // 如果当前节点就是目标节点的父节点，直接返回当前节点id
                // if (node.children && node.children.some(child => child.id === childId)) {
                //     res = node.children.some(child => child.id === childId)[0];
                //     return res;
                //
                // }
                // 否则继续遍历当前节点的子节点
                if (node.children) {
                    let now = this.getMyNode(node.children, childId,res);
                    if(now != null){
                        res = now;
                        return res;
                    }



                }
            }
            // 如果没有找到父节点，则返回null
            return null;
        },
        getAllLevels(tree, arr){//查找所有父节点 //data：要遍历的数据， target：查找目标， result用于装查找结果的数组

            for (let node of tree) {
                if(arr.indexOf(node.id) == -1){
                    arr.push(node.id);
                }
                if (node.children) {
                    this.getAllLevels(node.children, arr);

                }
            }

        },
        test(){
            let res = null;
            res = this.getMyNode(this.companyTree,"S2023062820295800000c0a8009b",res);

            this.getAllLevels(this.companyTree,this.levels);
            let result = [];
            if(res != null){
                this.getPids(this.companyTree, res, result);
            }
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }

    },
    created() {
        this.onSearch();
        this.loadUser();
        this.loadCompanyLevel();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
    .el-tooltip__popper{
        max-width:500px !important;
    }
    .table ::v-deep .el-table--medium .el-table__cell {
        padding: 0px !important;
    }
    ::v-deep .params .cell {
        padding: 0px !important;
        border: none;
    }

</style>
